export const MMMS_FUND_SELECTIONS = Object.freeze([
  "Retail Money Market Fund - Taxable",
  "Retail Money Market Fund - Municipal",
  "Government Money Market Fund - Taxable",
]);

export const MMMS_SELECTION_CONFIG = Object.freeze({
  label: "Money Market Fund Selection",
  options: MMMS_FUND_SELECTIONS,
});

export const isManagedMoneyMarketStrategyName = (strategy) =>
  String(strategy || "")
    .toLowerCase()
    .includes("managed money market solution");

export const getMmmsFundBondType = (selection) => {
  const normalized = String(selection || "").trim().toLowerCase();
  if (!normalized) return "";
  return normalized.endsWith(" - municipal") ? "Municipal" : "Taxable";
};

export const canonicalizeMmmsFundSelection = (value, bondType = "") => {
  const raw = String(value || "").trim();
  const exact = MMMS_FUND_SELECTIONS.find(
    (selection) => selection.toLowerCase() === raw.toLowerCase(),
  );
  if (exact) return exact;

  const normalized = raw.toLowerCase();
  if (normalized.includes("government money market")) {
    return "Government Money Market Fund - Taxable";
  }
  if (normalized.includes("retail money market")) {
    const municipal =
      normalized.includes("municipal") || bondType === "Municipal";
    return municipal
      ? "Retail Money Market Fund - Municipal"
      : "Retail Money Market Fund - Taxable";
  }
  return "";
};
